<template>
    <div>
        <SwipeModalComponent v-if="periodSelectionMenu.isVisible" @closeMenu="changePeriodSelectionMenuVisibility">
            <div class="content-wrapper">
                <h2>
                    Escolha o período <br>
                   (intervalo máximo de 1 mês entre as datas)
                </h2>

                <div class="period" v-for="(item, key) in period" :key="key">
                    <h1 class="dateLabel">{{ item.name }}</h1>
                    <h1 class="date" @click="openDateModal(item.name)">
                        {{ item.value }}
                        <i class="fa fa-regular fa-calendar"></i>
                    </h1>
                </div>

                <div class="buttons">
                    <button @click="resetPeriod">Limpar seleção</button>
                    <button @click="confirmPeriod">Confirmar</button>
                </div>
            </div>

        </SwipeModalComponent>
        <DateModal @closeModal="closeModal" :initialDate="initialDate" :disableDates="disableDates"/>
    </div>
</template>
<script >
import DateModal from '../modals/DateModal.vue'
import SwipeModalComponent from './SwipeModalComponent.vue'
import { showAlertNotification } from '@/libs/Util.js'
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'

export default {
    name: 'RechargeValueComponent',
    emits: ['changePeriod'],
    props: ['periodRaw'],
    components: {
        DateModal,
        SwipeModalComponent
    },
    data () {
        return {
            period: [],
            currentOpenedDate: '',
            openedInitialDate: false,
            initialDate: '',
            disableDates: false, // desabilita as datas do modal para o usuario conseguir selecionar um intervalo de 1 mes entre as datas inicial e final
            openedFinalDate: false
        }
    },
    computed: {
        ...mapGetters(['periodSelectionMenu', 'dateModal'])
    },
    methods: {
        ...mapActions(['changePeriodSelectionMenuVisibility', 'showDateModal', 'closeDateModal']),
        confirmPeriod () {
            // se a data inicial for maior que a final, troca as datas
            const initialDateMom = moment(this.period[0].value, 'DD/MM/YYYY')
            const finalDateMom = moment(this.period[1].value, 'DD/MM/YYYY')

            if (initialDateMom > finalDateMom && this.openedFinalDate === true) {
                const aux = this.period[0].value
                this.period[0].value = this.period[1].value
                this.period[1].value = aux
            }

            this.openedInitialDate = false
            this.$emit('changePeriod', this.period)
        },
        openDateModal (label) {
            // controle de qual data esta sendo aberta
            this.currentOpenedDate = label
            if (label === 'Data Inicial') {
                this.openedInitialDate = true
                this.disableDates = false
            } else {
                this.openedFinalDate = true
            }
            // nao deixa abrir o modal de data final se a data inicial nao estiver preenchida
            if (label === 'Data Final' && !this.openedInitialDate) {
                showAlertNotification({
                    title: '',
                    text: 'Preencha a data inicial primeiro'
                })
                return
            }
            this.showDateModal({
                text: 'Escolha a ' + label,
                icon: 'fa fa-regular fa-calendar'
            })
        },
        closeModal (date) {
            date = moment(date).format('DD/MM/YYYY') || moment(new Date()).format('DD/MM/YYYY')
            this.period.forEach(item => {
                if (item.name === this.currentOpenedDate) {
                    item.value = date
                }
                if (item.name === 'Data Inicial') {
                    this.initialDate = item.value
                    this.disableDates = true
                }
            })

            const initialDateMom = moment(this.period[0].value, 'DD/MM/YYYY')
            const finalDateMom = moment(this.period[1].value, 'DD/MM/YYYY')
            if (finalDateMom.diff(initialDateMom, 'months') >= 1) {
                this.period[1].value = moment(this.period[0].value, 'DD/MM/YYYY').add(1, 'months').format('DD/MM/YYYY')
            }

            // se a data inicial for maior que a final, troca as datas
            if (initialDateMom > finalDateMom && this.openedFinalDate === true) {
                const aux = this.period[0].value
                this.period[0].value = this.period[1].value
                this.period[1].value = aux
            }
        },
        resetPeriod () {
            this.period = JSON.parse(JSON.stringify(this.periodRaw))
            this.confirmPeriod()
        }
    },
    mounted () {
        this.period = JSON.parse(JSON.stringify(this.periodRaw))
    },
    watch: {
    }
}
</script>

<style lang="less" scoped>
.content-wrapper {
    max-width: 100%;

    h2 {
        text-align: center;
        &:last-of-type {
            margin-bottom: 40px;
        }
    }

    .period {
        // label, date, icon same distance for both initial and final date
        display: grid;
        // center the grid
        grid-template-columns: 3fr 1fr;
        border-bottom: solid #BAB8B8 2px;
        margin-bottom: 40px;
        padding-bottom: 10px;

        .dateLabel {
            color: #858585;
        }

        .date {
            display: flex;
            justify-content: flex-end;
            text-align: center;
            align-items: center;
            font-weight: 500;

            i {
                color: var(--iconColor);
                margin-left: 15px;
            }
        }
    }

    .buttons {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
    }

    button {
        text-align: right;
        border-radius: 5px;
        background-color: var(--buttonBackground);
        color: var(--buttonText);
        padding: 10px;
        border: none;
    }
}
</style>
